// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3XzFs","selected":"Chip_selected__kUlOe"};